@if (
  showUpdateBanner() &&
  ticketState() !== ticketStatus.CLOSED &&
  ticketState() !== ticketStatus.CANCELLED
) {
  <div class="chat-update-banner">
    <rs-web-icon
      [icon]="icons.Close"
      [color]="'white'"
      [size]="12"
      (tapped)="showUpdateBanner.set(false)"
    ></rs-web-icon>
    <div class="d-flex justify-content-between px-4 py-1 align-items-center">
      <div>{{ 'update_available' | translate }}</div>
      <rs-web-icon
        [icon]="icons.Refresh"
        [color]="'white'"
        [size]="15"
        (tapped)="refreshChat.emit()"
      ></rs-web-icon>
    </div>
  </div>
}

<div class="chat-body" #chatContainer>
  @if (!loading()) {
    @for (messageGroup of ticketChat(); track messageGroup; let i = $index) {
      @if (i === 0 || ticketChat()[i - 1].dayKey !== messageGroup.dayKey) {
        <div class="chat__day-separator">
          <span>{{ messageGroup.dayKey | dayLabel }}</span>
        </div>
      }
      <div class="chat" [class]="messageGroup.isIncoming ? 'flex-row' : 'flex-row-reverse'">
        <div class="chat__img" [class.chat__img--incoming]="messageGroup.isIncoming">
          {{ messageGroup.userInitials }}
        </div>
        <div class="chat__message-wrapper" [class.align-items-end]="!messageGroup.isIncoming">
          @for (item of messageGroup.messages; track item.id) {
            <div class="d-flex gap-2">
              @if (item.status === 'FAILED') {
                <button
                  im-circle-button
                  class="medium chat-retry-btn"
                  aria-label="Retry"
                  (click)="onRetryMessage(item.id)"
                >
                  <rs-web-icon [icon]="icons.Refresh1" [size]="14"></rs-web-icon>
                </button>
              }
              <div
                class="chat__message"
                [innerHTML]="item.message"
                [class.chat__message--incoming]="messageGroup.isIncoming"
                [class.chat__message--bordered]="
                  item.status === 'FAILED' || item.status === 'RETRIED'
                "
              ></div>
            </div>

            <div class="chat__notification">
              <time class="me-1">{{ item.timestamp | date: 'HH:mm' }}</time>
              @switch (item.status) {
                @case ('FAILED') {
                  <span class="failed">{{
                    'ticket_chat_message_status_failed_l' | translate
                  }}</span>
                }
                @case ('PENDING') {
                  <span>{{ 'ticket_chat_message_status_pending_l' | translate }}</span>
                }
                @case ('RETRIED') {
                  <span>{{ 'ticket_chat_message_status_retried_l' | translate }}</span>
                }
              }
            </div>
          }
        </div>
      </div>
    }
  } @else {
    <rs-web-ticket-details-chat-loader />
  }
</div>
<div class="chat-footer">
  <div class="d-flex align-items-center gap-2">
    <textarea
      class="form-control"
      [class.chat-footer__textarea--disabled]="
        ticketState() === ticketStatus.CLOSED ||
        ticketState() === ticketStatus.CANCELLED ||
        isReadOnly()
      "
      [(ngModel)]="message"
      [placeholder]="getTicketChatPlaceholder() | translate"
      [disabled]="
        ticketState() === ticketStatus.CLOSED ||
        ticketState() === ticketStatus.CANCELLED ||
        isReadOnly()
      "
    ></textarea>
    <button
      im-circle-button
      class="medium"
      aria-label="Send message"
      [disabled]="!message() || loading() || sending() || isReadOnly()"
      (click)="onSendMessage()"
    >
      <rs-web-icon [icon]="icons.PaperPlane" [size]="14"></rs-web-icon>
    </button>
  </div>
</div>
